import React from "react";

import Header from "./Header";
import Event from "./Event/Event";
import Footer from "./Footer/Footer";

const Home = () => {
  return (
    <div>
      {/* <Header></Header> */}
      <Event></Event>
      <Footer></Footer>
    </div>
  );
};

export default Home;
